import {Brand, BrandCode} from '../types'

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const brands = require('./brands') as Record<BrandCode, Brand>

export const defaultBrand = brands.vio

const brandsByCode = Object.fromEntries(
  Object.entries(brands).map(([_, config]) => [config.code, config])
)

export const getBrandByCode = (code: string): Brand => brandsByCode[code]
